import { centerAlign, elementAlignCssClass } from "../elementAlignement.js";
import { elementSizeCssClass, medium } from "../size/index.js";
import defineElement from "../helpers/defineElement.js";

export const horizontalDirection = "horizontal";

export const verticalDirection = "vertical";

/**
 * Layout element to space renderables.
 * By default, it will horizontally space the element with a "medium" gap.
 *
 * It will wrap each child into a div.stacker-item so that text nodes can be
 * handled gracefully. This can be turned on by passing `noWrap: true`.
 *
 * @param {object} [options]
 * @param {"horizontal"|"vertical"} [options.direction] - Specify in which direction to
 *   render its children
 * @param {ElementSize} [options.size] - Size of the space
 *   between each child
 * @param {"after"|"before"|"between"} [options.spacing] - Set the spacing policy
 * @param {boolean} [options.noWrap] - When true, doesn't wrap the child elements in a
 *   div. Use it when you know that all the children are wrapped already
 * @param {ElementAlign} [options.align] - Specify how to align children
 * @param {boolean} [options.isBlock] - When true, the stacker takes full width
 * @param {boolean} [options.reversed] - When true, render the children in a
 *   reverse order
 */

export default defineElement(
	"stacker",
	(
		{
			direction = horizontalDirection,
			size = medium,
			spacing,
			noWrap = false,
			align = centerAlign,
			isBlock = false,
			reversed = false,
		},
		children,
	) => ({
		options: {
			class: [
				{
					horizontal: direction === horizontalDirection,
					vertical: direction === verticalDirection,
					spacing,
					between: spacing === "between",
					before: spacing === "before",
					after: spacing === "after",
					"is-block": isBlock,
					reversed,
				},
				elementAlignCssClass("space", align),
				elementSizeCssClass("space", size),
			],
		},
		children: noWrap
			? children
			: children.map(
					(child) => (html) =>
						html.div({ class: "stacker-item" }, child),
				),
	}),
);
